export class LocationWaysFactorData
{
    colId:number;
    placeId:number;
    value:number;
}